export default "__VITE_ASSET__BEYRfczT__"